import { render, staticRenderFns } from "./Page_CompleteAccount.vue?vue&type=template&id=b94fa35a&scoped=true&"
import script from "./Page_CompleteAccount.vue?vue&type=script&lang=js&"
export * from "./Page_CompleteAccount.vue?vue&type=script&lang=js&"
import style0 from "./Page_CompleteAccount.vue?vue&type=style&index=0&id=b94fa35a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94fa35a",
  null
  
)

export default component.exports